<template>
  <div v-if="loaded" class="align-center d-flex justify-center" style="height: 300px">
    <h1 class="text-age">
      {{ dados.idade_media_em_anos | parseNumberToFloatBR }}
    </h1>
    <h1 class="text-age-more">anos</h1>
  </div>
</template>

<script>
  import DashboardService from '@/services/DashboardService';

  export default {
    name: 'IdadeMediaAtivo',
    props: {
      nome: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        loaded: false,
        dados: {
          idade_media_em_anos: 0
        }
      };
    },
    mounted() {
      this.getDados();
    },
    methods: {
      getDados() {
        DashboardService.getDados('IdadeMediaAtivo')
          .then((response) => {
            this.loaded = true;
            this.dados = response.data;
          })
          .catch((err) => {
            console.log('Erro: ', err);
            this.$toast.error(`Erro ao buscar os dados do painel "${this.nome}".`, '', { position: 'topRight' });
          });
      }
    }
  };
</script>

<style scoped>
  .text-age {
    font-size: 120px;
    color: #550899;
    font-family: 'styreneA';
  }

  .text-age-more {
    font-weight: normal;
    color: #969696;
    font-family: 'styreneA';
  }
</style>
